import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselWrapper, Slide, SlideImage } from "./MinggoCarousel.styles";
import minggoShopfront from "../../images/division_minggo.webp";
import minggoCarousel2 from "../../images/minggo_carousel_2.webp";
import minggoCarousel3 from "../../images/minggo_carousel_3.webp";
import minggoCarousel4 from "../../images/minggo_carousel_4.webp";

const slides = [
  { src: minggoShopfront, alt: "MinGGo storefront — infants, toys, and gifts" },
  { src: minggoCarousel2, alt: "MinGGo — toys and games aisle" },
  { src: minggoCarousel3, alt: "MinGGo — dolls and playsets display" },
  { src: minggoCarousel4, alt: "MinGGo — plush toys and gifts" },
];

const MinggoCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
  };

  return (
    <CarouselWrapper>
      <Slider {...settings}>
        {slides.map((item) => (
          <Slide key={item.alt}>
            <SlideImage src={item.src} alt={item.alt} />
          </Slide>
        ))}
      </Slider>
    </CarouselWrapper>
  );
};

export default MinggoCarousel;
